import { Box, Typography } from '@mui/material';

function GraphSubHeader({ children }) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%', pt: 1, pb: 5 }}>
            <Typography variant="h5" component="h5" sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                {children}
            </Typography>
        </Box>
    )
}

export default GraphSubHeader;